<template>
  <div class="container">
    <header-app
      to="detail"
      :param="{ id: hotel.slug }"
      class="header-brand"
      :title="$t('Restaurant')"
      :headerleft="showItem"
    >
      <template v-slot:header-left> 
        <span @click="closeItem()">
          <base-icon icon_name="arrow-left" />
          <a class="header-nav-title" href="#">{{ $t('Menu List') }}</a></span>
      </template>

      <template v-slot:icon-more>
        <base-icon icon_name="dollar-sign"  @click.native="setToggleCurrency()" /> 
      </template>
    </header-app>

    <wrap v-if="!showItem & !toggleCurrency"> 
      <h2 class="text-center">{{ hotel.title }}</h2>
      <br>
      <!-- <div class="row">
        <carousel
          :per-page="1"
          :mouse-drag="true"
          :spacePadding="10"
          class="mb-3"
          :paginationColor="`rgba(123, 11, 207, 0.31)`"
          :paginationActiveColor="`rgb(123, 11, 207)`"
          :touchDrag="true"
        >
          <slide v-for="(promotion, index) in promotions" :key="index">
            <img :src="promotion.image_url" class="img-fluid image-slide" alt />
          </slide>
        </carousel>
      </div>-->

      <!-- search -->
      <div class="input-group search shadow-sm mb-3">
        <input
          v-model="search"
          type="text"
          class="form-control input-search"
          :placeholder="$t('finding_here')"
          aria-describedby="inputGroup-sizing-lg"
          autocomplete="true"
          @keyup.enter="getCategoryChild(selected_category)"
        />
        <div class="input-group-prepend">
          <span
          style="border-radius: 100px;"
            class="input-group-text icon-input"
            @click="getCategoryChild(selected_category)"
          >
            <base-icon icon_name="search" />
          </span>
        </div>
      </div>
      <!-- end search -->

      <p>{{ $t("Browse by Category") }}</p>
      <div class="row">
        <div class="cate-item m-1">
          <button
            type="button"
            class="btn  shadow-sm m-1"
            style="padding-left: 20px; padding-right: 20px"
            @click="allItem()"
          >
            {{ $t("All") }}
          </button>
          <button
            v-if="meta_category.id > 0"
            type="button"
            class="btn  m-1"
            @click="backButton(meta_category)"
          >
            <base-icon icon_name="arrow-left-circle" />
          </button>
          <button
            v-for="cate in map_categories"
            :key="cate.title"
            type="button"
            :class="{ selected: selected_category.id === cate.id }"
            class="btn btn-light category-li m-1"
            @click="getCategoryChild(cate)"
          >
            {{ cate.title }}
          </button>
        </div>
      </div>

      <br />
      <p>{{ $t("Menu List") }}</p>
      <div class="row">
        <template>
          <item-card
            v-for="(item, i) in map_items"
            :key="`${item.id}_${i}`"
            :item="item"
            @click.native="openItem(item)"
          />
        </template>
      </div>

      <div class="row">
              <loading-location v-if="loading" />
      </div>
      
      <div class="text-center mt-5" v-if="map_items.length <= 0 && !loading"> 
            <div>
                <img src="@/assets/icon/icon01.svg" class="not_found" alt />
                <h6 class="mt-2">{{ $t("item_not_found") }}</h6>
            </div> 
      </div> 
       
      <button
        v-if="load_more & !loading"
        type="button" 
        class="btn btn-round center mb-10"
        @click="load_more_menu()"
      >
        {{ $t("more") }}
      </button>

    
      <div v-if="qty > 0" class="d-flex justify-content-between wrap-botttom-action">
        <button
          type="button"
          class="btn btn-brand shadow btn-md"
          @click="openBasket()"
        >
          <base-icon icon_name="arrow-right-circle" />
          {{ $t("Check Out") }}  ({{ qty }})
        </button>

        <div class="sub">
          <p class="text-right">{{ $t("sub_total") }}</p>
          <p  class="text-right"> {{  sub_total |  exchange_rate_left  }}</p> 
        </div>

      </div>
    </wrap>

    <transition name="fade">
      <wrap v-if="showItem & !toggleCurrency">
        <div  class="row" v-if="item.id > 0">  
          <div class="col-sm-12 col-md-6" >  
            <base-item-slider
              :images="item.images"
              class="image-big-item"
            ></base-item-slider>
          </div>
          <div class="col-sm-12 col-md-6">
            <h5>{{ item.title }}</h5>
            <p>{{ item.description }}</p>
            <hr />
            <div class="option-group mb-2">
              <h6 class="mb-0">
                {{ $t("price") }}: {{ item.price | exchange_rate_left }}
              </h6>
            </div>
            <template v-if="item.options.length > 0">
              <div
                v-for="(option, index) in item.options"
                :key="option.id"
                class="option-group mb-2"
              >
                <h6>{{ option.title }}</h6>
                <div
                  v-for="opl in option.optionvalues"
                  :key="opl.id + opl.title"
                >
                  <template v-if="option.type === 'Option'">
                    <label class="radio-app">
                      {{ opl.title }}
                      <input
                        :id="opl.title"
                        v-model="item_selected_radio[index]"
                        type="radio"
                        :value="[
                          option.id,
                          opl.id,
                          opl.price,
                          option.title,
                          opl.title,
                        ]"
                      />
                      <span class="radio-app-mark" />
                      <span class="float-right">
                        <template v-if="opl.price >= 0">
                          + {{ opl.price | exchange_rate_left }}
                        </template>
                        <template v-else>
                          - {{  (opl.price * -1) | exchange_rate_left }}</template
                        >
                      </span>
                    </label> 
                  </template>
                  <template v-else>
                    <label class="checkbox-label">
                      <input
                        v-model="item_selected_checkbox"
                        type="checkbox"
                        :name="'group_' + option.title + option.id"
                        :value="[
                          option.id,
                          opl.id,
                          opl.price,
                          option.title,
                          opl.title,
                        ]"
                      />
                      <span class="checkbox-mark" />
                      {{ opl.title }}
                      <span class="float-right">
                        <template v-if="opl.price >= 0">
                          + {{ opl.price | exchange_rate_left }}
                        </template>
                        <template v-else>
                          - {{  (opl.price * -1) | exchange_rate_left }}</template
                        >
                      </span>
                    </label>
                  </template>
                </div>
              </div>
            </template> 

            <div class="option-noted option-group shadow-sm mb-2">
              <div class="form-group">
                <input
                  v-model="note"
                  class="form-control"
                  :placeholder="$t('Note')"
                />
              </div>
                <div class="d-flex flex-row-reverse bd-highlight m-2">
               <btn-qty v-model="qtyOrder"></btn-qty><p class="mt-2">{{ $t('qty')}}</p> 
            </div>
            </div>

          

            <div class="option-add">           
              <button
                v-if="enable_add_item"
                type="button"
           
                class="btn  btn-block btn-brand shadow-sm  btn-md"
                @click="addOrder(item)"
              >
                <base-icon icon_name="plus-circle" />
                {{ $t("add") }}
              </button>
                 <button type="button" class="btn btn-block btn-close" @click="closeItem()">
                {{ $t("Back") }}
              </button>
            </div>
          </div>
        </div>
      </wrap>
    </transition>

    <transition name="fade">
      <wrap v-if="toggleCurrency">
        <change-currency />
      </wrap>
    </transition>
  </div>
</template>  
<style lang="css">
</style>
<script>
import store from "@/store";
import redirectLogin from '@/helper/redirect';
export default {
  layout: "default",
  name: "Menu",
  metaInfo: {
    title: "DiscoverLao Ordering",
  },
  middleware: "auth",
  data: () => ({
    map_categories: [],
    meta_category: {},
    selected_category: {
      id: 0,
    },
    remark: false,
    note: "",
    map_items: [],
    showItem: false,
    search: "",
    item: {},
    item_selected: [],
    item_selected_checkbox: [],
    item_selected_radio: [],
    next_page: 1,
    load_more: true,
    currency_selected: {},
    enable_add_item: false,
    qtyOrder: 1
  }),
  computed: {
    loading_promotion() {
      return store.getters["promotion/loading"];
    },

    toggleCurrency() {
      return store.getters["nav/toggleCurrency"];
    },
    selected_currency() {
      return store.getters["currency/selected_currency"];
    },
    meta() {
      return store.getters["item/meta_item"];
    },
    items() {
      return store.getters["item/items"];
    },
    categories() {
      return store.getters["item/categories"];
    },
    sub_total() {
      let total_price = 0;
      _.forEach(this.orders, function (el) {
        total_price = Number(total_price) + Number(el.total_price);
      });
      return total_price;
    },
    orders() {
      return store.getters["order/order"];
    },
    loading() {
      return store.getters["item/item_loading"];
    },
    hotel() {
      return store.getters["location_selected/placeSelected"] || {};
    },
    hotelType() {
      return store.getters["location_selected/placeType"];
    },
    btnState() {
      return store.getters["location_selected/btnState"];
    },
    qty() {
      let qty = 0;
      _.forEach(this.orders, function (el) {
        qty = qty + el.qty;
      });
      return qty;
    },
  },
  watch: {
    item_selected_checkbox: function (value) {
      if (value.length > 0) {
        this.enable_add_item = true;
      }
    },
    item_selected_radio: function (value) {
      if (value.length > 0) {
        this.enable_add_item = true;
      }
    },
  },
  mounted() {
    // this.refreshRestaurant();
    this.load_data();
    this.loadItem();
    this.getProfile();
    // this.removeOrderInfo();
  },
  methods: {
    // async refreshRestaurant() {
    //   let _slug = localStorage.getItem("_slug");
    //   let _action = localStorage.getItem("_action");
    //   if (!_slug || !_action) {
    //     window.location.href = process.env.VUE_APP_DOMAIN;
    //     return;
    //   }
    //   await store.dispatch("location_selected/setBtnState", _action);
    //   await store.dispatch("location/get_restaurant", _slug); 
    //   let hotel = await store.getters["location/restaurant"]; 
    //   store.commit("location_selected/SELECTED_LOCATION", hotel);
    //   let checkDefault = _.find(hotel.currencies, function (el) {
    //     return el.default === true;
    //   });
    //   if (checkDefault) {
    //     this.$store.dispatch("currency/setCurrency", checkDefault);
    //   }
    // },

    setToggleCurrency() {
      this.$store.dispatch("nav/SetToggleCurrency");
    },
    allItem() {
      this.selected_category = {
        id: 0,
      };
      this.meta_category = [];
      this.load_data();
      this.loadItem(this.selected_category, false);
    },
    
    addOrder(item) {
      if (!store.getters['auth/user']){
         window.location.href =  redirectLogin;
         return;
      }

      if(this.qtyOrder == 0) return  
      let vm = this;
      let key_map = item.id;

      _.forEach(this.item_selected_checkbox, function (ol) {
        if (ol) {
          key_map = key_map + "_" + ol[0] + "_" + ol[1];
          vm.item_selected.push(ol);
        }
      });

      _.forEach(this.item_selected_radio, function (ol) {
        if (ol) {
          key_map = key_map + "_" + ol[0] + "_" + ol[1];
          vm.item_selected.push(ol);
        }
      });
 
      let data = {
        item_id: item.id,
        qty: this.qtyOrder,
        price: item.price,
        description: item.description,
        title: item.title,
        total_price: item.price ,
        options: [],
        note: this.note,
        key_id: key_map,
        key_price_per_set: 0,
      };
      let options = [];
      _.forEach(this.item_selected, function (el) {
        let exist = _.find(options, function (ld) {
          return ld.option_id === el[0];
        });
        if (!exist) {
          options.push({
            option_id: el[0],
            title: el[3],
          });
        }
      });

      if (options.length > 0) {
        _.forEach(options, function (op) {
          let opls = [];
          let optionvalues = _.filter(vm.item_selected, function (opl) {
            return opl[0] === op.option_id;
          });
          _.forEach(optionvalues, function (ll) {
            opls.push({
              opion_value_id: ll[1],
              price: ll[2],
              title: ll[4],
            });
            data.total_price = Number(data.total_price) + Number(ll[2]);
          });
          data.options.push({
            option_id: op.option_id,
            title: op.title,
            optionvalues: opls,
          });
        });
      }

      data.key_price_per_set = data.total_price;
      data.total_price = data.total_price * this.qtyOrder;
      this.$store.dispatch("order/setOrder", data);
      this.note = "";
      this.closeItem();
    },
    closeItem() {
      (this.item = {}), (this.showItem = false);
      this.item_selected = [];
      this.item_selected_checkbox = [];
      this.item_selected_radio = [];
      window.scrollTo(0,0);
    },
    openItem(item) {
       this.qtyOrder = 1
      this.item = item;
      this.showItem = true;
      this.remark = false;
      let options = item.options || [];
      let values_default = [];
      // :value="[option.id,opl.id,opl.price,option.title,opl.title]"
      let vm = this;
      if (options.length > 0) {
        _.forEach(options, function (menu) {
          if (menu.type === "Option") {
            if (menu.optionvalues.length > 0) {
              _.forEach(menu.optionvalues, function (menu_op, index) {
                if (index === 0) {
                  vm.item_selected_radio.push([
                    menu.id,
                    menu_op.id,
                    menu_op.price,
                    menu.title,
                    menu_op.title,
                  ]);
                }
              });
            }
          } else {
            vm.item_selected_radio.push(null);
          }
        });
      }

      if (item.options.length <= 0) {
        this.enable_add_item = true;
      } else {
        this.enable_add_item = false;
      }
      window.scrollTo(0,0);
    },
    async loadItem(category, next, clearAppend) {
      let data = {
        type: this.hotelType,
        type_id: this.hotel.id,
        limit: 100,
        category_id: 0,
        search: this.search,
        next_page: this.next_page,
        order_type: this.btnState,
      };
      if (!next) {
        this.map_items = [];
        this.load_more = true;
        data.next_page = 1;
      }
      if (category) {
        data.category_id = category.id;
      }
      await store.dispatch("item/fetchItem", data);

      if (this.items.length > 0) {
        if (clearAppend) {
          this.map_items = [];
        }
        this.items.forEach((el) => {
          this.map_items.push(el);
        });
      } else {
        this.load_more = false;
      }
      if (this.next_page >= this.meta.last_page) {
        this.load_more = false;
      } else {
        this.load_more = true;
      }
    },
    openBasket() {
      this.$router.push({ name: "basket" });
    },
    async getCategoryChild(child) {
      let data = _.filter(this.categories, function (el) {
        return el.parent_id === child.id;
      });
      this.load_more = true;
      await this.loadItem(child, false, true);
      if (!data.length > 0) {
        this.selected_category = child;
      } else {
        this.selected_category = {};
        this.map_categories = data;
        this.meta_category = child;
      }
    },
    backButton(child) {
      let data = _.filter(this.categories, function (el) {
        return el.parent_id === child.parent_id;
      });
      this.map_categories = data;
      var parent_id = 0;
      if (child.parent_id === 0) {
        parent_id = child.id;
      } else {
        parent_id = child.parent_id;
      }
      var previousParent = _.find(this.categories, function (el) {
        return el.id === parent_id;
      });
      if (child.parent_id === 0) {
        this.meta_category = [];
        this.loadItem();
        this.selected_category.id = 0;
      } else {
        this.meta_category = previousParent;
        this.selected_category = child;
        this.loadItem(child);
      }
    },
    async load_data() {
      let data = {
        type: this.hotelType,
        type_id: this.hotel.id,
      };

      await store.dispatch("item/fecthCategory", data);
      if (this.categories) {
        let data = _.filter(this.categories, function (el) {
          return el.parent_id === 0;
        });
        this.map_categories = data;
      }
    },
    async load_more_menu() {
      var vm = this;
      vm.next_page = vm.meta.current_page + 1;
      if (vm.next_page > vm.meta.last_page) {
        vm.load_more = false;
        return;
      }
      vm.loadItem(vm.selected_category, true);
    },
    async getProfile() {
        await store.getters["auth/user"];
      
    },
    async removeOrderInfo() {
      this.$store.dispatch("order/clearOrderInfo");
    },
  },
};
</script>
 